import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaders, HttpClient} from '@angular/common/http';
import {ApiService} from './api.service';
import {SubDomainResponse} from "@core/shared/models/subdomain";

@Injectable({
    providedIn: 'root'
})
export class SubDomainService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public isValidDomain(data: object): Observable<SubDomainResponse> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<SubDomainResponse>(`${this._apiService.getApiUrl(false, true)}/channels/validate/subDomain`, data, {
            headers: headers
        });
    }
}
